import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPhone,
  faEnvelopeCircleCheck,
  faLocationDot,
  faCopyright,
} from '@fortawesome/free-solid-svg-icons';
import LOGO from '../images/logo-hvi-nt.png';
import {
  FooterElement,
  FooterInnerCon,
  FullFooter,
  FooterLogoCon,
} from './Footer.styled';

const Footer = () => {
  return (
    <FullFooter>
      <FooterInnerCon>
        <FooterLogoCon>
          <img src={LOGO} alt="Noaly" width={100} height={100} />
          <p>Noaly</p>
        </FooterLogoCon>
        <FooterElement>
          <h2>Kontakt</h2>
          <a href="callto:20741066" className="footerNav">
            <FontAwesomeIcon icon={faPhone} /> 20741066
          </a>
          <a href="mailto:info@noaly.dk" className="footerNav">
            <FontAwesomeIcon icon={faEnvelopeCircleCheck} /> info@noaly.dk
          </a>
          <a href="/" className="footerNav">
            <FontAwesomeIcon icon={faLocationDot} /> 2300 København S
          </a>
        </FooterElement>

        <FooterElement>
          <h2>Firma</h2>
          <Link to="/appudvikling">Appudvikling</Link>
          <Link to="/webudvikling">Webudvikling</Link>
          <Link to="/cases">Cases</Link>
          <Link to="/kontakt">Kontakt</Link>
        </FooterElement>
        <FooterElement>
          <h2>Sociale</h2>
          <a href="callto:20741066" className="footerNav">
            Linkedin
          </a>
          <a href="mailto:info@noaly.dk" className="footerNav">
            Instagram
          </a>
          <a href="callto:20741066" className="footerNav">
            Facebook
          </a>
          <a href="mailto:info@noaly.dk" className="footerNav">
            Github
          </a>
        </FooterElement>
      </FooterInnerCon>
      <p style={{ padding: '10px' }}>
        <FontAwesomeIcon icon={faCopyright} /> Noaly • 2300 København S, Danmark • CVR: 43057960 • Tlf. 20 74 10 66
      </p>
    </FullFooter>
  );
};

export default Footer;
